import React, { useEffect, useState } from "react";
import { fetchStudentResponsesSummary } from "../pages/services/studentResponseService";
import "../styles/StudentResponsesSummary.css";

// Summary for the Student Responses screen, mirroring the Test Score Summary:
// headline totals, a split by where the questions came from, then one row per
// student. It re-fetches with the filters, so it always describes exactly the
// rows listed below it.
const StudentResponsesSummary = ({ filters }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const scope = JSON.stringify(filters || {});

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchStudentResponsesSummary(JSON.parse(scope))
      .then((d) => !cancelled && setData(d))
      .catch((e) => !cancelled && setError(e.message))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, [scope]);

  if (loading) return <div className="srs-state">Loading summary…</div>;
  if (error) return <div className="srs-state srs-state-error">{error}</div>;
  if (!data || !data.totals.total) {
    return <div className="srs-state">No responses match these filters.</div>;
  }

  const { totals, byType, rows } = data;

  return (
    <div className="srs-card">
      <h3 className="srs-heading">Summary</h3>

      <div className="srs-tiles">
        <div className="srs-tile">
          <div className="srs-tile-label">Responses</div>
          <div className="srs-tile-value">{totals.total}</div>
        </div>
        <div className="srs-tile">
          <div className="srs-tile-label">Accuracy</div>
          <div className="srs-tile-value">{totals.accuracy}%</div>
        </div>
        <div className="srs-tile">
          <div className="srs-tile-label">Correct</div>
          <div className="srs-tile-value srs-correct">{totals.correct}</div>
        </div>
        <div className="srs-tile">
          <div className="srs-tile-label">Incorrect</div>
          <div className="srs-tile-value srs-incorrect">{totals.incorrect}</div>
        </div>
      </div>

      <div className="srs-split">
        <section className="srs-block">
          <h4 className="srs-block-title">By question source</h4>
          <table className="srs-table">
            <thead>
              <tr>
                <th>Source</th>
                <th className="srs-num">Total</th>
                <th className="srs-num">Correct</th>
                <th className="srs-num">Incorrect</th>
                <th className="srs-num">Accuracy</th>
              </tr>
            </thead>
            <tbody>
              {byType.map((t) => (
                <tr key={t.label}>
                  <td>{t.label}</td>
                  <td className="srs-num">{t.total}</td>
                  <td className="srs-num srs-correct">{t.correct}</td>
                  <td className="srs-num srs-incorrect">{t.incorrect}</td>
                  <td className="srs-num srs-acc">{t.accuracy}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="srs-block">
          <h4 className="srs-block-title">By student</h4>
          <table className="srs-table">
            <thead>
              <tr>
                <th>Student</th>
                <th className="srs-num">Total</th>
                <th className="srs-num">Correct</th>
                <th className="srs-num">Incorrect</th>
                <th className="srs-num">Accuracy</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.studentId}>
                  <td>{r.studentName}</td>
                  <td className="srs-num">{r.total}</td>
                  <td className="srs-num srs-correct">{r.correct}</td>
                  <td className="srs-num srs-incorrect">{r.incorrect}</td>
                  <td className="srs-num srs-acc">{r.accuracy}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </div>
  );
};

export default StudentResponsesSummary;
